import {
  Feedback as FeedbackIcon,
  Logout as LogoutIcon,
  ManageAccounts as UserManagementIcon,
  QuestionAnswer as FAQIcon,
} from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";

import { SidebarItem } from "@/components/layout/Sidebar/SidebarItem";
import { SidebarSection } from "@/components/layout/Sidebar/SidebarSection";
import { useAuth } from "@/contexts/AuthContext";
import { paths } from "@/routes/paths";
import { UserRole } from "@/utils/roleManager";

interface UtilitiesSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  userHasPermission: (role: UserRole) => boolean;
  onLogoutClick?: () => void;
  isMobile?: boolean;
  onItemSelect?: () => void;
}

export const UtilitiesSection: React.FC<UtilitiesSectionProps> = ({
  isExpanded,
  onToggle,
  userHasPermission,
  onLogoutClick,
  isMobile = false,
  onItemSelect,
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isAssociate = user?.role === UserRole.ASSOCIATE;
  return (
    <SidebarSection
      title={t("nav.sections.utilities")}
      isExpanded={isExpanded}
      onToggle={onToggle}
      isMobile={isMobile}
    >
      {!isAssociate && (
        <SidebarItem
          label={t("settings.tabs.userManagement")}
          path={paths.utilities.userManagement}
          icon={<UserManagementIcon />}
          minimumRole={UserRole.STORE_ADMIN}
          userHasPermission={userHasPermission}
          isMobile={isMobile}
          afterSelect={onItemSelect}
        />
      )}

      <SidebarItem
        label={t("help.tabs.faq")}
        icon={<FAQIcon />}
        minimumRole={UserRole.CRAVE_ADMIN}
        userHasPermission={userHasPermission}
        isMobile={isMobile}
        path={paths.utilities.faq}
        afterSelect={onItemSelect}
      />
      <SidebarItem
        label={t("help.tabs.feedback")}
        icon={<FeedbackIcon />}
        minimumRole={UserRole.NONE}
        userHasPermission={userHasPermission}
        isMobile={isMobile}
        path={paths.utilities.feedback}
        afterSelect={onItemSelect}
      />
      {/* Profile is intentionally hidden until the account flow is functional. */}

      <SidebarItem
        label={t("common.signOut")}
        path="/logout"
        icon={<LogoutIcon />}
        onClick={onLogoutClick}
        minimumRole={UserRole.NONE}
        userHasPermission={userHasPermission}
        isMobile={isMobile}
        afterSelect={onItemSelect}
      />
    </SidebarSection>
  );
};
